module.exports = __webpack_public_path__ + "img/dsci0090.828066fc.jpg";